import styled from "styled-components";
import { SyncFilled } from "@assets";

export const RootContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  background: ${(props) => props.theme.golden};
  border-radius: 12px;
  padding: 20px 13px;
  margin-bottom: 20px;
  gap: 4px;
  width: ${(props) => props.width};
  @media screen and (max-width: 380px) {
    flex-wrap: wrap;
    justify-content: space-around;
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const MyWalletTitle = styled.span`
  color: ${(props) => props.theme.textColor};
  font-weight: 400;
  font-size: 12px;
  padding-bottom: 5px;
`;

export const MyWalletContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.light ? props.theme.white : props.theme.textColor};
  border-radius: 23px;
  padding: 5px 5px 5px 10px;
  cursor: pointer;
  height: 20px;
`;

export const MyWalletLabel = styled.span`
  color: ${(props) =>
    props.light ? props.theme.textColor : props.theme.white};
  padding-right: 5px;

  font-size: 12px;

  @media screen and (max-width: 420px) {
    padding-right: 2px;
  }

  @media screen and (max-width: 410px) {
    font-size: 11px;
  }
`;

export const ReloadIcon = styled(SyncFilled)`
margin-right: 5px;
`;